import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { RFQStatus } from '@steelbuy/ts-shared';

export interface MyRFQsContextValue {
    myRFQFilter: RFQStatus[];
    setMyRFQFilter: (filter: RFQStatus[]) => void;
}

const defaultValue: MyRFQsContextValue = {
    myRFQFilter: [],
    setMyRFQFilter: () => null,
};

const MyRFQsContext = createContext(defaultValue);

export const MyRFQsContextProvider = ({ children }: { children: ReactNode }) => {
    const [myRFQFilter, setMyRFQFilter] = useState<RFQStatus[]>([]);
    const value = useMemo(
        () => ({
            myRFQFilter,
            setMyRFQFilter,
        }),
        [myRFQFilter, setMyRFQFilter]
    );

    return <MyRFQsContext.Provider value={value}>{children}</MyRFQsContext.Provider>;
};

export const useMyRFQsContext = () => useContext(MyRFQsContext);
